var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stream/icon/tco",
    transform: "translate(0.000000, -1.000000)",
    fill: "#006A35",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,19.5 L22,19.5 C22.8284271,19.5 23.5,20.1715729 23.5,21 C23.5,21.8284271 22.8284271,22.5 22,22.5 L2,22.5 C1.17157288,22.5 0.5,21.8284271 0.5,21 L0.5,2 C0.5,1.17157288 1.17157288,0.5 2,0.5 C2.82842712,0.5 3.5,1.17157288 3.5,2 L3.5,19.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2565447,12.6625371 L17.6420844,2.77623088 C17.9780048,2.01896673 18.864206,1.67740015 19.6214701,2.01332055 C20.3787343,2.34924096 20.7203009,3.23544213 20.3843805,3.99270627 L15.7147114,14.5195243 C15.5346315,14.9254778 15.1839218,15.2307655 14.7570235,15.3531779 L7.7911215,17.3506397 C6.99478689,17.5789874 6.16411772,17.118543 5.93576999,16.3222084 C5.70742226,15.5258738 6.16786661,14.6952046 6.96420122,14.4668569 L13.2565447,12.6625371 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.ad9c1fb593f8a768419f3968ca04fc73.svg";
export { ForwardRef as ReactComponent };